import React from 'react'
import ProductCardSkeleton from './ProductCardSkeleton'
import ShopCardSkeleton from './ShopCardSkeleton'
import ShopCategories from './ShopCategoriesSkelton'

const HomeSkeleton = (): JSX.Element => {
  return (
    <div className="space-y-7">

      {/* Banner */}
      {/* <MainBannerSkeleton /> */}

      {/* Flash Sale */}
      <section>
        <div className="h-8 w-[170px] bg-gray-200 rounded animate-pulse my-4" />

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {Array.from({ length: 3 }).map((_, index) => (
            <ProductCardSkeleton key={index} />
          ))}
        </div>
      </section>

      {/* Shops */}
      <section>
        <div className="h-8 w-[210px] bg-gray-200 rounded animate-pulse mb-4" />

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-5">
          {Array.from({ length: 3 }).map((_, index) => (
            <ShopCardSkeleton key={index} />
          ))}
        </div>
      </section>

      {/* Categories */}
      <section>
        <div className="h-8 w-[200px] bg-gray-200 rounded animate-pulse mb-4" />

        <div className="grid grid-cols-4 gap-2">
          {Array.from({ length: 4 }).map((_, index) => (
            <ShopCategories key={index} />
          ))}
        </div>
      </section>

    </div>
  )
}

export default HomeSkeleton
